import ResultsListItem from './ResultsListItem'

export default ResultsListItem
